import { createContext } from "react";

export const initialShareFeedbackContext = {
    canShareFeedback: false,
    showShareFeedbackModal: () => {},
};

export const ShareFeedbackContext = createContext(initialShareFeedbackContext);
